import React from "react";

function MassMixerMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Mass Mixer Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Mass Mixer Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE CENTERED */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/21.png"
                        alt="Mass Mixer Machine"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Mass Mixer Machine</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Mass Mixer Machine is designed for uniform mixing of
                      wet and dry ingredients, widely used in pharmaceutical,
                      food, and chemical industries. Its heavy-duty mixing arm
                      and trough ensure consistent blending of materials.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      With stainless steel contact parts, robust construction,
                      tilting mechanism, and efficient gear-driven operation,
                      this machine provides smooth mixing with minimal
                      maintenance.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/21.png"
                            alt="Mass Mixer Side View"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/22.png"
                            alt="Mass Mixer Closeup"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    {/* Table 1 */}
                    <h5 style={{ marginTop: "20px" }}>Small Capacity Models</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-MM-25</td>
                          <td>DPM-MM-50</td>
                          <td>DPM-MM-100</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>25 kg</td>
                          <td>50 kg</td>
                          <td>100 kg</td>
                        </tr>

                        <tr>
                          <td>Total Volume</td>
                          <td>40 L</td>
                          <td>75 L</td>
                          <td>150 L</td>
                        </tr>

                        <tr>
                          <td>Motor Power</td>
                          <td>1.5 HP</td>
                          <td>2 HP</td>
                          <td>3 HP</td>
                        </tr>

                        <tr>
                          <td>Mixing Speed</td>
                          <td>32 RPM</td>
                          <td>32 RPM</td>
                          <td>32 RPM</td>
                        </tr>

                      </tbody>
                    </table>

                    {/* Table 2 */}
                    <h5 style={{ marginTop: "20px" }}>Large Capacity Models</h5>
                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-MM-150</td>
                          <td>DPM-MM-200</td>
                        </tr>

                        <tr>
                          <td>Working Capacity</td>
                          <td>150 kg</td>
                          <td>200 kg</td>
                        </tr>

                        <tr>
                          <td>Total Volume</td>
                          <td>230 L</td>
                          <td>300 L</td>
                        </tr>

                        <tr>
                          <td>Motor Power</td>
                          <td>5 HP</td>
                          <td>7.5 HP</td>
                        </tr>

                        <tr>
                          <td>Mixing Speed</td>
                          <td>32 RPM</td>
                          <td>32 RPM</td>
                        </tr>

                      </tbody>
                    </table>

                    {/* Common Features */}
                    <h5 style={{ marginTop: "20px" }}>Material & Build</h5>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Construction</td>
                          <td colSpan="3">Stainless Steel 304 / 316 (optional)</td>
                        </tr>

                        <tr>
                          <td>Trough Tilting</td>
                          <td colSpan="3">Manual / Motorized</td>
                        </tr>

                        <tr>
                          <td>Drive System</td>
                          <td colSpan="3">Heavy-duty Gearbox Driven</td>
                        </tr>

                      </tbody>
                    </table>

                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/multi-mill">
                          Multi Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/colloid-mill-machine">
                          Colloid Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/oscillating-granulator">
                          Oscillating Granulator
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default MassMixerMachine;
